import util from '@/libs/util'

// 用户账号密码登录
export function login(data) {
  return util.http({
    method: 'post',
    url: 'system/auth/login',
    data
  })
}

// 用户账号验证码登录
export function loginCaptcha(params) {
  return util.http({
    method: 'post',
    url: 'system/auth/login/captcha',
    params
  })
}

// 登录用户个人资料
export function loginProfile() {
  return util.http({
    method: 'get',
    url: 'system/auth/login/profile'
  })
}

// 获取登录用户所属公司
export function loginCompanyName() {
  return util.http({
    method: 'get',
    url: 'system/auth/login/companyName'
  })
}

// 用户账号切换
export function switchLogin(data) {
  return util.http({
    method: 'post',
    url: 'system/auth/login/switch',
    data
  })
}

// 修改登录用户个人资料
export function loginProfileEdit(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/login/profile',
    data
  })
}

// 修改登录用户密码
export function loginPasswordEdit(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/login/password',
    data
  })
}

// 用户账号注销
export function logout() {
  return util.http({
    method: 'post',
    url: 'system/auth/login/logout'
  })
}

// 注册获取验证码
export function registerCaptcha(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/register/captcha',
    params
  })
}

// 注册校验验证码
export function checkCaptcha(params) {
  return util.http({
    method: 'put',
    url: 'system/auth/register/captcha',
    params
  })
}

// 注册
export function register(data) {
  return util.http({
    method: 'post',
    url: 'system/auth/register/captcha',
    data
  })
}

// 忘记密码获取验证码
export function forgetCaptcha(params) {
  return util.http({
    method: 'get',
    url: 'system/auth/admin/captcha',
    params
  })
}

// 忘记密码校验验证码
export function forgetCheckCaptcha(params) {
  return util.http({
    method: 'put',
    url: 'system/auth/admin/captcha',
    params
  })
}

// 忘记密码重置密码
export function passwordReset(data) {
  return util.http({
    method: 'put',
    url: 'system/auth/admin/captcha/password',
    data
  })
}
